import React from 'react';
import { Box, Typography, Divider, Paper } from '@mui/material';
import useTranslate from '../../Hooks/useTranslate';
import { SchemaRenderer } from './SchemaRenderer';

/**
 * Groups fields under a heading without nesting their values.
 *
 * `object` is the other grouping type; it puts its children under its own key, which suits a nested
 * payload. A group leaves `basePath` alone, so it lays out a flat document - a customer's
 * attributes, say - into sections without changing where any value is read from or written to.
 *
 * Field properties read: `label`, `itemSchema` and `flat` (drop the surrounding paper).
 */
export const GroupField = ({ basePath, field }) => {
  const translate = useTranslate();

  const body = (
    <>
      {field.label && (
        <Box sx={{ mb: 1 }}>
          <Typography
            variant="h6"
            color="primary.main"
            sx={{ fontWeight: 600 }}
          >
            {translate(field.label)}
          </Typography>
          <Divider sx={{ mt: 1 }} />
        </Box>
      )}
      <Box sx={{ pl: field.label ? 1 : 0 }}>
        <SchemaRenderer
          fields={field.itemSchema || []}
          basePath={basePath}
          columns={field.columns}
          spacing={field.spacing}
        />
      </Box>
    </>
  );

  if (field.flat) return <Box sx={{ width: '100%' }}>{body}</Box>;

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 3,
        mb: 3,
        mt: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        borderRadius: '12px',
      }}
    >
      {body}
    </Paper>
  );
};

export default GroupField;
